import {Observable}  from 'rxjs';
import {filter, map} from 'rxjs/operators';

import UiEventType            from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const createVolumeSliderTapSream = (uiEvents$: Observable<IUiEventsStreamPayload>): Observable<number> =>
    uiEvents$
        .pipe(
            filter(({type}) => type === UiEventType.VOLUME_SLIDER_TAP),
            map(({eventData}) => eventData.multiplier)
        );

export default createVolumeSliderTapSream;